/* template */
<template><div class="calendar-container"><div class="calendar-header"><div class="calendar-title" v-if="(title)">{{ title }}</div><slot/><week :firstDay="(firstDay)"/></div><mpx-scroll-view scroll-y :class="({range:type === 'range'})" :scroll-into-view="(scrollview)" class="calendar-body"><month v-for="(item, index) in (months)" :key="item" :firstDay="(firstDay)" :id='("month"+(index))' :type="(type)" :color="(color)" :date="(item)" :minDate="(minDate)" :maxDate="(maxDate)" :startText="(startText)" :endText="(endText)" :currentDate="(currentDate)" :calendarHoliday="(calendarHoliday)" :subTexts="(subTexts)" :disableDate="(disableDate)" @click="onSelected"/></mpx-scroll-view><div class="calendar-footer" v-if="(type === 'range')"><div class="confirm-tip" v-if="(startTip || endTip)"><div class="confirm-tip-item" v-if="(startTip)">{{startTip}}</div><div class="confirm-tip-item" v-if="(endTip)">{{endTip}}</div></div><Button :disabled="(forbidden)" @click="onConfirm" class="confirm-button">确定</Button></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m664bbfd5"}'>
  .calendar-container
    display flex
    flex-direction column
    background-color #fff
    padding-bottom 30px
    .calendar-header
      flex-shrink 0
      .calendar-title
        height 25px
        font-weight 500
        line-height 25px
        text-align center
        font-family PingFangSC-Medium
        font-size 18px
        color #000
        padding 16px 0
    .calendar-body
      height 413px
      &.range
        height 360px
    .calendar-footer
      box-sizing border-box
      padding 0 20px
      font-family PingFang SC
      .confirm-tip
        display flex
        align-items center
        margin 20px 0 6px
        font-size 13px
        font-weight 500
        color #333
        &-item:first-child
          margin-right 28px
      .confirm-button
        margin-top 10px
        height 50px
        line-height 50px
        border-radius 10px
        background #FF6400
        color #fff
        font-weight 600
        font-size 16px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m664bbfd5"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex664bbfd5%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex664bbfd5%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m664bbfd5"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index664bbfd5/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'week':getComponent(require("./week.mpx?isComponent&outputPath=components%2Fweekb43d2202%2Findex")),'month':getComponent(require("./month.mpx?isComponent&outputPath=components%2Fmonth48f43283%2Findex")),'Button':getComponent(require("../ts-button/index.mpx?isComponent&outputPath=components%2Findex9b0ba146%2Findex")),'mpx-scroll-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-scroll-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
